<script setup lang="ts">
import MazPagination, { type Props } from "maz-ui/components/MazPagination";
import { getBlog } from "~/api/blog";

const router = useRouter();
const blogs = ref<any>([]);
const currentPage = ref(1);
const totalPages = ref(0);

const searchText = ref("");
let debounceTimeout: any = null; // buat delay manual

const query = ref({
  limit: 12,
  page: 1,
  search: "",
  blog_category: null,
});

const props: Props = {
  resultsSize: 100,
  totalPages: 10,
  activeColor: "primary",
};

const fetchBlog = async () => {
  try {
    const { status, data } = await getBlog(query.value);
    if (status) {
      blogs.value = data.data;
      totalPages.value = data.last_page;
    }
  } catch (error) {
    console.error("Error fetching page blog:", error);
  }
};

onMounted(async () => {
  await fetchBlog();
});

watch(searchText, (val) => {
  clearTimeout(debounceTimeout);

  debounceTimeout = setTimeout(() => {
    query.value.search = val;
    query.value.page = 1;
    fetchBlog();
  }, 1500);
});


const setPagination = (value: any) => {
  query.value.page = value;
  fetchBlog();
};

const setCategoriesHandler = (id: any) => {
  console.log("blog cate", id);
  query.value.blog_category = id;
  fetchBlog();
};
</script>

<template>
  <div class="relative h-[70vh] w-full">
    <NuxtImg
      src="/assets/blog-banner.png"
      alt="blog-banner"
      quality="30"
      decoding="async"
      priority
      class="absolute inset-0 w-full h-full object-cover scale-100 object-bottom place-items-center z-0"
    />

    <div
      class="absolute inset-0 z-10 bg-gradient-to-tr from-black/80 to-transparent"
    ></div>

    <div
      class="container relative z-20 flex flex-col justify-end pb-20 h-full text-white px-4"
    >
      <div class="text-2xl lg:text-4xl max-w-md font-bold">
        Best Scooters to Rent in Bali in 2025
      </div>
      <p class="text-sm lg:text-base font-light mt-2">
        Renting a scooter in Bali is the best way to explore the island with
        ease.
      </p>
    </div>
  </div>

  <div class="container py-6">
    <div class="flex items-center justify-between">
      <div>
        <h1 class="text-xl font-medium">Blog</h1>
        <div>
          Here, we share travel tips, destination guides, and stories that
          inspire your next adventure.
        </div>
      </div>

      <ClientOnly>
        <MazInput v-model="searchText" placeholder="Search ..." class="max-w-md rounded-2xl my-4">
          <template #right-icon>
            <Icon name="mdi:search" size="25" />
          </template>
        </MazInput>
      </ClientOnly>
    </div>
  </div>

  <div class="container">
    <BlogCategories @setCategories="setCategoriesHandler" />
  </div>

  <div class="container flex flex-col sm:flex-row gap-4">
    <section>
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        <template v-for="item in blogs" :key="item.id" cl>
          <div class="border border-slate-200 shadow-lg p-2 rounded-xl">
            <NuxtImg
              preset="thumb"
              :src="item.images"
              :alt="item.title"
              class="rounded-xl mb-4 h-[225px] object-cover mx-auto"
            />

            <div class="flex flex-wrap gap-2 mb-4">
              <div
                v-for="category in item.blog_categories"
                class="bg-primary py-2 px-4 text-xs rounded-lg text-white max-w-max"
              >
                {{ category.category }}
              </div>
            </div>

            <div class="font-bold !text-xl">{{ item.title }}</div>

            <div class="text-gray-500">
              <p class="text-sm flex items-center mt-2">
                <Icon name="mdi-clock" class="mr-2" />
                {{ item.created_at }}
              </p>

              <div
                class="mb-4 mt-2 overflow-hidden max-h-[75px] sm:h-[75px] relative"
              >
                <div class="line-clamp-3">
                  <span v-html="item.description"></span>
                </div>
              </div>

              <a
                class="text-gray-600 font-semibold flex items-center cursor-pointer"
                @click="() => router.push(`/blog/${item.slug}`)"
                >Read More <Icon name="mdi:arrow-right" class="ml-2"
              /></a>
            </div>
          </div>
        </template>
      </div>

      <div v-if="totalPages > 1" class="flex justify-center">
        <ClientOnly>
          <MazPagination
            v-bind="props"
            v-model="currentPage"
            class="mt-6 mb-8 sm:mb-0"
            :total-pages="totalPages"
            size="xs"
            @update:model-value="setPagination"
          />
        </ClientOnly>
      </div>
    </section>
  </div>

  <LandingPromo class="!py-0 mt-6 !rounded-0" isSquare />
</template>
